import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAdminAuth } from '../../context/AdminAuthContext'
import logoSrc from '../../../assets/vfied_mark.png'
import './LoginPage.css'

export default function LoginPage() {
  const { login, me } = useAdminAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const [login_val, setLoginVal] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const sessionExpired = new URLSearchParams(location.search).get('reason') === 'session_expired'
  const from = (location.state as { from?: Location })?.from?.pathname || '/admin/dashboard'

  useEffect(() => {
    if (me) navigate(from, { replace: true })
  }, [me, navigate, from])

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!login_val.trim() || !password.trim()) {
      setError(t('admin.login.error_empty'))
      return
    }
    setError('')
    setLoading(true)
    try {
      await login({ login: login_val, password })
      navigate(from, { replace: true })
    } catch (err: any) {
      const code = err?.response?.data?.errorCode
      if (code === 'AUTH_FAILED') setError(t('admin.login.error_invalid'))
      else if (code === 'NOT_ADMIN') setError(t('admin.login.error_not_admin'))
      else setError(t('admin.login.error_failed'))
      console.error('[ERROR] Admin login failed:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="admin-login">
      <div className="admin-login__card">
        <div className="admin-login__logo">
          <img src={logoSrc} alt="Verrafied" />
        </div>
        <h1 className="admin-login__title">{t('admin.login.title')}</h1>

        {sessionExpired && (
          <div className="admin-login__notice">{t('admin.login.session_expired')}</div>
        )}

        <form className="admin-login__form" onSubmit={handleSubmit}>
          <div className="admin-login__field">
            <label className="admin-login__label">{t('admin.login.label_login')}</label>
            <input
              className={`admin-login__input${error ? ' admin-login__input--error' : ''}`}
              type="text"
              value={login_val}
              onChange={(e) => { setLoginVal(e.target.value); setError('') }}
              autoFocus
              autoComplete="username"
              disabled={loading}
            />
          </div>
          <div className="admin-login__field">
            <label className="admin-login__label">{t('admin.login.label_password')}</label>
            <input
              className={`admin-login__input${error ? ' admin-login__input--error' : ''}`}
              type="password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError('') }}
              autoComplete="current-password"
              disabled={loading}
            />
          </div>
          {error && <p className="admin-login__error">{error}</p>}
          <button
            className="admin-login__btn"
            type="submit"
            disabled={loading}
          >
            {loading ? t('admin.login.signing_in') : t('admin.login.sign_in')}
          </button>
        </form>
      </div>
    </div>
  )
}
